import { useEffect, useLayoutEffect } from 'react';

/**
 * useLayoutEffect on the client, useEffect on the server.
 *
 * React warns when useLayoutEffect runs during server rendering, where it
 * cannot do anything useful. Components that are server-rendered — every
 * modal reachable through a `?modal=` deep link is — but need layout-phase
 * timing on the client use this instead.
 */
export const useIsomorphicLayoutEffect = import.meta.env.SSR
  ? useEffect
  : useLayoutEffect;
